// extracted by mini-css-extract-plugin
export default {"btn":"btn--os8z8","btnIsDisabled":"btnIsDisabled--RqD8s"};